/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export function FavIcon({ fill }: { fill: string }) {
  return (
    <svg width="10" height="13" viewBox="0 0 10 13" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.59961 11.6L4.59961 9.15556L0.599609 11.6V1.82223C0.599609 1.49807 0.720017 1.1872 0.934344 0.957987C1.14867 0.728776 1.43936 0.600006 1.74247 0.600006H7.45675C7.75986 0.600006 8.05055 0.728776 8.26487 0.957987C8.4792 1.1872 8.59961 1.49807 8.59961 1.82223V11.6Z"
        stroke="#4E6088"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
